import { render, staticRenderFns } from "./PopupViewGuestListItems.vue?vue&type=template&id=97c22248&scoped=true&"
import script from "./PopupViewGuestListItems.vue?vue&type=script&lang=js&"
export * from "./PopupViewGuestListItems.vue?vue&type=script&lang=js&"
import style0 from "./PopupViewGuestListItems.vue?vue&type=style&index=0&id=97c22248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c22248",
  null
  
)

export default component.exports